import React, { useEffect, useState, useRef } from 'react';
import { ChevronDown } from 'lucide-react';
import { CarCard } from './CarCard';
import { vehicles } from '../data/vehicles';
function parsePrice(price: string): number {
  return Number(price.replace(/[$.]/g, ''));
}
type SortOrder = 'none' | 'asc' | 'desc';
interface CarListingGridProps {
  searchQuery?: string;
  selectedType?: string | null;
}
export function CarListingGrid({
  searchQuery = '',
  selectedType
}: CarListingGridProps) {
  const [sortOpen, setSortOpen] = useState(false);
  const [sortOrder, setSortOrder] = useState<SortOrder>('none');
  const dropdownRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    function handleClickOutside(e: MouseEvent) {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target as Node)) {
        setSortOpen(false);
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);
  const filteredCars = vehicles.filter(car => {
    if (selectedType && car.type !== selectedType) return false;
    if (!searchQuery.trim()) return true;
    const query = searchQuery.toLowerCase();
    const searchString = `${car.year} ${car.make} ${car.model} ${car.trim}`.toLowerCase();
    return searchString.includes(query);
  });
  const sortedCars = [...filteredCars].sort((a, b) => {
    if (sortOrder === 'desc') return parsePrice(b.price) - parsePrice(a.price);
    if (sortOrder === 'asc') return parsePrice(a.price) - parsePrice(b.price);
    return 0;
  });
  const sortLabel = sortOrder === 'desc' ? 'Mayor precio' : sortOrder === 'asc' ? 'Menor precio' : 'Ordenar';
  return <div className="w-full" data-id="element-24">
      {/* Results Bar */}
      <div className="flex flex-col sm:flex-row sm:items-center justify-between mb-6 gap-4" data-id="element-25">
        <span className="text-[15px] text-gray-500" data-id="element-26">
          {filteredCars.length}{' '}
          {filteredCars.length === 1 ? 'resultado' : 'resultados'}
          {searchQuery.trim() && ` para "${searchQuery.trim()}"`}
        </span>

        <div className="flex items-center gap-6" data-id="element-27">
          <div className="relative" ref={dropdownRef} data-id="element-28">
            <button onClick={() => setSortOpen(!sortOpen)} className="flex items-center gap-2 text-[15px] font-medium text-[#1C1C1C] hover:text-[#4A90E2] transition-colors" data-id="element-29">
              <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-30">
                <line x1="21" y1="10" x2="3" y2="10" data-id="element-31"></line>
                <line x1="21" y1="6" x2="3" y2="6" data-id="element-32"></line>
                <line x1="21" y1="14" x2="3" y2="14" data-id="element-33"></line>
                <line x1="21" y1="18" x2="3" y2="18" data-id="element-34"></line>
              </svg>
              {sortLabel}
              <ChevronDown className={`w-4 h-4 text-gray-500 transition-transform ${sortOpen ? 'rotate-180' : ''}`} data-id="element-35" />
            </button>

            {sortOpen && <div className="absolute right-0 top-full mt-2 bg-white border border-[#D5D5D5] rounded-lg shadow-lg py-1 z-50 min-w-[160px]" data-id="element-36">
                <button onClick={() => {
              setSortOrder('desc');
              setSortOpen(false);
            }} className={`w-full text-left px-4 py-2.5 text-[14px] transition-colors ${sortOrder === 'desc' ? 'text-[#4A90E2] font-semibold bg-gray-50' : 'text-gray-700 hover:bg-gray-50 hover:text-[#4A90E2]'}`} data-id="element-37">
                  Mayor precio
                </button>
                <button onClick={() => {
              setSortOrder('asc');
              setSortOpen(false);
            }} className={`w-full text-left px-4 py-2.5 text-[14px] transition-colors ${sortOrder === 'asc' ? 'text-[#4A90E2] font-semibold bg-gray-50' : 'text-gray-700 hover:bg-gray-50 hover:text-[#4A90E2]'}`} data-id="element-38">
                  Menor precio
                </button>
              </div>}
          </div>
        </div>
      </div>

      {/* Grid */}
      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6" data-id="element-39">
        {sortedCars.length > 0 ? sortedCars.map(car => <CarCard key={car.id} {...car} data-id="element-40" />) : <div className="col-span-full text-center py-16" data-id="element-41">
            <p className="text-lg text-gray-500" data-id="element-42">
              No se encontraron autos para "{searchQuery}"
            </p>
            <p className="text-sm text-gray-400 mt-2" data-id="element-43">
              Intentá con otra búsqueda
            </p>
          </div>}
      </div>
    </div>;
}